module.exports = __webpack_public_path__ + "img/vip_bg_5.bea94313.png";